import { CommonServices, SharedValidators } from 'src/modules/shared';
import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { AppFilter } from 'src/modules/shared/models/filter';
import { takeUntil, map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-foreign-detail',
  templateUrl: './foreign-details.component.html',
  styleUrls: ['./foreign-details.component.scss'],
})
export class ForeignDetailsComponent {
  private unsubscribe$: Subject<void> = new Subject<void>();

  public msg;
  sidebar: any;
  loadingScroll: boolean;
  foreignDetails: any;
  messageOn: boolean = false;
  success;
  //loading icon on clicking register.

  pending: boolean;

  error: string | null;

  constructor(private commonServices: CommonServices, private router: Router) {
    this.pending = true;
    this.commonServices.getForeignDetailse({}).subscribe((res: any) => {
      this.foreignDetails = res.mailTemplate;
      this.pending = false;
    });
    this.pending = true;
    this.commonServices
      .getTemplate({ messageTemplateId: 'TERMS_AND_CONDITIONS_SIDE_BAR' })
      .subscribe((res: any) => {
        this.sidebar = res.mailTemplate;
        this.pending = false;
      });
  }

  ngOnInit() {}
}
